import { type Maybe } from '@amazon/vinyl-util'

export function omit<T, Props extends (keyof T)[]>(
    object: Maybe<T>,
    props: Props
): Omit<T, Props[number]> | null {
    if (!object) return null
    const out: any = {}
    for (const key of Object.keys(object)) {
        if (props.includes(key as keyof T)) continue
        out[key] = object[key as keyof T]
    }
    return out
}

export function pick<T extends object, K extends keyof T>(obj: T, ...keys: K[]): Pick<T, K> {
    const result = {} as Pick<T, K>
    for (const key of keys) {
        if (key in obj) {
            result[key] = obj[key]
        }
    }
    return result
}
